export default {
	state: {
		// versionNumber:	'6.0.72d',
		versionNumber:	'1.0.0',
	},
}